import React from "react";

import Form from "../components/Form/Form";

function Login() {
  return (
    <div>
      <Form login={true}></Form>
    </div>
  );
}

export default Login;
